import { action } from 'satcheljs';
export const initializeDynamicLayout = action('initializeDynamicLayout');
